import type {
  BetterstartIntegrationDefinition,
  InstalledIntegrationManifest
} from '@cli-types/integration-engine/integrations.js'
import { integrationManifestStore } from '@integration-engine/manifests/integration-manifest-store.js'
import { createInstallableRuntime } from '@next-adapter/installable-runtime/create-installable-runtime.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { readIntegrationTemplate } from '@next-adapter/integration-template-reader/read-integration-template.js'
import { getPresetDefinition } from '@next-adapter/preset-registry.js'

export const integrationFiles = createInstallableRuntime<
  BetterstartIntegrationDefinition,
  InstalledIntegrationManifest
>({
  familySegment: 'integrations',
  readExtensionTemplate: (integrationId, relativePath) =>
    readIntegrationTemplate(integrationId, relativePath),
  getDefinition: (integrationId) => getIntegrationDefinition(integrationId),
  getCrossDefinition: (presetId) => getPresetDefinition(presetId),
  loadManifest: integrationManifestStore.load,
  saveManifest: integrationManifestStore.save
})
